import TroodyApi from '@/services/troody/TroodyApi'

const sections = {
  cobra: { id: 1, section: 'OE_Cobra', name: 'COBRA' },
  eligibility: { id: 2, section: 'OE_Eligibility', name: 'Eligibility' },
  jobClass: { id: 3, section: 'OE_JobClass', name: 'Job Class' },
  location: { id: 4, section: 'OE_Location', name: 'Location' },
  payGroup: { id: 5, section: 'OE_PayGroup', name: 'Pay Group' },
  renewal: { id: 6, section: 'OE_Renewal', name: 'Renewal' },
  openEnrollments: { id: 7, section: 'Open_Enrollments', name: 'Open Enrollment' },
  deduction: { id: 8, section: 'OE_Deduction', name: 'Deduction' },
  eligibilityGroup: { id: 9, section: 'OE_Eligibility_Group', name: 'Eligibility Group' },
  enrollers: { id: 10, section: 'OE_Enrollers', name: 'Enrollers' },
}

const approvalTypes = [
  'projectManager',
  'caseBuilder',
  'broker',
]

export default class Approvals {
  constructor (openEnrollmentId, associatedWith, isTemplate = false, oeEligibilityGroupId = null) {
    this.openEnrollmentId = openEnrollmentId
    this.associatedWith = associatedWith
    this.isTemplate = isTemplate
    this.oeEligibilityGroupId = oeEligibilityGroupId

    if (isTemplate) {
      this.approvalResource = new TroodyApi('oeApprovalTemplate/')
      this.productTemplateId = associatedWith
      this.oeEligibilityGroupId = oeEligibilityGroupId
    } else {
      this.approvalResource = new TroodyApi('oeApproval/')
      this.approvalSectionId = associatedWith
    }
    this.reset()
  }

  static get sections () {
    return sections
  }

  get approvalTypes () {
    return approvalTypes
  }

  get loading () {
    return (this.loadingDetails || this.saving)
  }

  get color () {
    return this.complete ? 'green' : this.approvalCount ? 'amber' : 'red'
  }

  get section () {
    let output = {}

    Object.entries(sections).forEach(([key, value]) => {
      if (value.id === this.associatedWith) {
        output = value
      }
    })

    return output
  }

  reset () {
    this.loadingDetails = false
    this.saving = false
    this.approvalsFetched = false
    this.data = null
    this.complete = false
    this.approvalCount = 0
    this.parseApprovals()
  }

  formatDate (dt) {
    const d = new Date(dt)
    return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
  }

  parseApprovals () {
    let approval = {}
    if (this.data && this.data.length) {
      approval = this.data[0]
    }

    this.projectManager = {
      title: 'Project Manager',
      id: approval.projectManagerId,
      date: this.formatDate(approval.projectManagerDate),
      username: approval.projectManagerUsername,
      name: approval.projectManagerName,
      email: approval.projectManagerEmail,
    }

    this.caseBuilder = {
      title: 'Case Builder',
      id: approval.caseBuilderId,
      date: this.formatDate(approval.caseBuilderDate),
      username: approval.caseBuilderUsername,
      name: approval.caseBuilderName,
      email: approval.caseBuilderEmail,
    }

    this.broker = {
      title: 'Broker',
      id: approval.brokerId,
      date: this.formatDate(approval.brokerDate),
      username: approval.brokerUsername,
      name: approval.brokerName,
      email: approval.brokerEmail,
    }

    this.complete = (this.projectManager.id && this.caseBuilder.id && this.broker.id)
    this.approvalCount = (this.projectManager.id ? 1 : 0) + (this.caseBuilder.id ? 1 : 0) + (this.broker.id ? 1 : 0)
  }

  loadDetails () {
    this.reset()
    this.loadingDetails = true
    const promise = new Promise((resolve, reject) => {
      const params = {
        openEnrollmentId: this.openEnrollmentId,
      }

      if (this.isTemplate) {
        params.productTemplateId = this.associatedWith
        params.oeEligibilityGroupId = this.oeEligibilityGroupId
      } else {
        params.approvalSectionId = this.associatedWith
      }

      this.approvalResource.query(params)
        .then(data => {
          this.approvalsFetched = true
          this.loadingDetails = false
          this.data = data
          this.parseApprovals()
          resolve(this.data)
        })
        .catch(error => {
          this.loadingDetails = false
          this.error = error
          reject(this.error)
        })
      })

    return promise
  }

  approve (isApproval) {
    this.saving = true
    const promise = new Promise((resolve, reject) => {
      const payload = {
        openEnrollmentId: this.openEnrollmentId,
        associatedWith: this.associatedWith,
        oeEligibilityGroupId: this.oeEligibilityGroupId,
        isTemplate: this.isTemplate,
        isApproval,
      }

      this.approvalResource.post(payload, 'approve')
        .then((data) => {
          this.saving = false
          this.data = data
          this.parseApprovals()
          resolve(data)
        })
        .catch((error) => {
          this.saving = false
          this.error = error
          reject(this.error)
        })
    })

    return promise
  }
}
